export default {
  username: 'Username',
  password: 'Password',
  rememberPwd: 'Remember Password',
  submit: 'Login',
  usernameRequired: 'Please enter username',
  passwordRequired: 'Please enter password',
}
